import { fromJS } from 'immutable';
import getRootState from './rootStateSelector';

export const getWalletState = (state) => {
  const rootState = getRootState(state) || fromJS({});
  return rootState.get('wallet');
};

export const getUserWallet = (state) => {
  const walletState = getWalletState(state);
  const wallet = walletState ? walletState.get('wallet') : [];
  return wallet;
};

export const getWalletIsLoading = (state) => {
  const walletState = getWalletState(state);
  const isLoading = walletState.get('isLoading');
  return isLoading;
};
